import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, Optional, SimpleChanges} from '@angular/core';
import {Artifact} from '@webmate-web-core/shared/types/artifact';
import {WorkbenchCommandRegistry} from '../../services/workbench-command-registry.service';
import {faExternalLink} from '@fortawesome/pro-solid-svg-icons';
import {ArtifactId} from '@webmate-web-core/shared/types/ids';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {DatePipe} from '@angular/common';
import {ArtifactService} from '@webmate-web-core/shared/services/artifact.service';
import {take} from 'rxjs/operators';

@Component({
    selector: 'wm-mail-overview',
    standalone: true,
    templateUrl: './mail-overview.component.html',
    imports: [
        FaIconComponent,
        DatePipe,
    ],
    styleUrls: ['./mail-overview.component.less']
})

export class MailOverviewComponent implements OnInit, OnChanges {

    // Either input should be provided

    @Input() mail: Artifact;

    @Input() mailId: ArtifactId;

    constructor(@Optional() protected workbenchCommandRegistry: WorkbenchCommandRegistry, private artifactService: ArtifactService, private cdRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.loadMailIfNeeded();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.mailId || changes.mail) {
            this.loadMailIfNeeded();
        }
    }

    private loadMailIfNeeded() {
        if (this.mailId && (!this.mail || this.mail.id !== this.mailId)) {
            this.artifactService.getArtifact$(this.mailId).pipe(take(1)).subscribe(mail => {
                this.mail = mail;
                this.cdRef.markForCheck();
            });
        }
    }

    openMail(mailId: ArtifactId) {
        if (this.workbenchCommandRegistry) {
            this.workbenchCommandRegistry.executeCommand("mail:openMail", {mailId: mailId});
        }
    }

    protected readonly externalLink = faExternalLink;
}
